<template>
    <div>
        <div class="vx-row mb-6 ">
            <div class="vx-col w-full sm:w-full md:w-full lg:w-4/12 xl:w-4/12">
                <product-image />
            </div>

            <div class="vx-col w-full sm:w-full md:w-full lg:w-8/12 xl:w-8/12">
                <menus />
                <product-type />
                <product-desc-details />

                <vs-divider border-style="dashed" class="mt-base mb-base" />

                <product-config />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Menus from '@/components/menu/MenuCombo'
    import vSelect from 'vue-select'
    import ProductImage from './ProductImage'
    import ProductType from './ProductType'
    import ProductConfig from './ProductConfig'
    import ProductDescDetails from './ProductDescDetail'

    export default {
        components : {
            ProductDescDetails,
            ProductConfig,
            ProductType,
            ProductImage,
            Menus,
            vSelect
        },

        computed : {
            ...mapState('product', ['productInfo'])
        },

        methods : {
            
        }
    }
</script>